import { createRoutine } from 'redux-saga-routines'
import { call, put, takeLatest, fork } from '@redux-saga/core/effects'
import * as portfolioService from 'services/portfolioService'
import { toast } from 'react-toastify'
import { getApiErrors } from 'utils/errors'

export const listPortfoliosRoutine = createRoutine('LIST_PORTFOLIOS')
export const getPortfolioRoutine = createRoutine('GET_PORTFOLIO')
export const createPortfolioRoutine = createRoutine('CREATE_PORTFOLIO')
export const updatePortfolioRoutine = createRoutine('UPDATE_PORTFOLIO')
export const deletePortfolioRoutine = createRoutine('DELETE_PORTFOLIO')
export const addBpsToPortfolioRoutine = createRoutine('ADD_BPS_TO_PORTFOLIO')
export const removeBpFromPortfolioRoutine = createRoutine('REMOVE_BP_FROM_PORTFOLIO')

function* listPortfolios() {
  yield put(listPortfoliosRoutine.request())
  try {
    const { data } = yield call(portfolioService.listPortfolios)
    yield put(listPortfoliosRoutine.success(data.data))
  } catch (error) {
    const msg = getApiErrors(error)
    msg && toast.error(msg)
    yield put(listPortfoliosRoutine.failure(error))
  }
}

function* getPortfolio({ payload }) {
  yield put(getPortfolioRoutine.request())
  try {
    const { data } = yield call(portfolioService.getPortfolio, payload)
    yield put(getPortfolioRoutine.success(data.data))
  } catch (error) {
    const msg = getApiErrors(error)
    msg && toast.error(msg)
    yield put(getPortfolioRoutine.failure(error))
  }
}

function* createPortfolio({ payload }) {
  yield put(createPortfolioRoutine.request())
  try {
    const { data } = yield call(portfolioService.createPortfolio, payload)
    yield put(createPortfolioRoutine.success(data.data))
    toast.success('Portfolio created')
  } catch (error) {
    const msg = getApiErrors(error)
    msg && toast.error(msg)
    yield put(createPortfolioRoutine.failure(error))
  }
}

function* updatePortfolio({ payload: { id, ...body } }) {
  yield put(updatePortfolioRoutine.request())
  try {
    const { data } = yield call(portfolioService.updatePortfolio, id, body)
    yield put(updatePortfolioRoutine.success(data.data))
    toast.success('Portfolio updated')
  } catch (error) {
    const msg = getApiErrors(error)
    msg && toast.error(msg)
    yield put(updatePortfolioRoutine.failure(error))
  }
}

function* deletePortfolioSaga({ payload }) {
  yield put(deletePortfolioRoutine.request())
  try {
    yield call(portfolioService.deletePortfolio, payload)
    yield put(deletePortfolioRoutine.success(payload))
    toast.success('Portfolio deleted')
  } catch (error) {
    const msg = getApiErrors(error)
    msg && toast.error(msg)
    yield put(deletePortfolioRoutine.failure(error))
  }
}

function* addBpsToPortfolio({ payload: { portfolioId, bpIds } }) {
  yield put(addBpsToPortfolioRoutine.request())
  try {
    yield call(portfolioService.addBuildingPassports, portfolioId, bpIds)
    const { data } = yield call(portfolioService.getPortfolio, portfolioId)
    yield put(getPortfolioRoutine.success(data.data))
    yield put(addBpsToPortfolioRoutine.success())
    toast.success('Buildings added')
  } catch (error) {
    const msg = getApiErrors(error)
    msg && toast.error(msg)
    yield put(addBpsToPortfolioRoutine.failure(error))
  }
}

function* removeBpFromPortfolio({ payload: { portfolioId, bpId } }) {
  yield put(removeBpFromPortfolioRoutine.request())
  try {
    yield call(portfolioService.removeBuildingPassport, portfolioId, bpId)
    const { data } = yield call(portfolioService.getPortfolio, portfolioId)
    yield put(getPortfolioRoutine.success(data.data))
    yield put(removeBpFromPortfolioRoutine.success())
    toast.success('Building removed')
  } catch (error) {
    const msg = getApiErrors(error)
    msg && toast.error(msg)
    yield put(removeBpFromPortfolioRoutine.failure(error))
  }
}

function* portfolioSaga() {
  yield takeLatest(listPortfoliosRoutine.TRIGGER, listPortfolios)
  yield takeLatest(getPortfolioRoutine.TRIGGER, getPortfolio)
  yield takeLatest(createPortfolioRoutine.TRIGGER, createPortfolio)
  yield takeLatest(updatePortfolioRoutine.TRIGGER, updatePortfolio)
  yield takeLatest(deletePortfolioRoutine.TRIGGER, deletePortfolioSaga)
  yield takeLatest(addBpsToPortfolioRoutine.TRIGGER, addBpsToPortfolio)
  yield takeLatest(removeBpFromPortfolioRoutine.TRIGGER, removeBpFromPortfolio)
}

export { portfolioSaga }
